<template>
  <base-layout page-default-back-link="/AttivitaLista">
    <div :style="{ float: 'left', width: '40%', 'max-width': '200px', padding: '10px' }" v-if="pAtt_Codi.Ats_dimi != '0%'">
      <img v-if="Dettagli.Att_imgc != null" v-bind:src="$SITE_URL + Dettagli.Att_imgc" style="width: 100%" />
    </div>
    <div style="float: none">
      <p v-html="Dettagli.Attivita" style="padding: 10px"></p>
    </div>
    <span v-if="Dettagli.Tags">
      <ion-chip
        v-for="item in JSON.parse(Dettagli.Tags)"
        :key="item"
        outline
        color="primary"
        :router-link="{ name: 'AttivitaLista', params: { pSearch: item.t } }"
        ><ion-label v-html="item.t"></ion-label
      ></ion-chip>
    </span>

    <ion-row style="margin-bottom: 0px" v-if="VisualizzaMappa">
      <ion-col size="8" style="height: 40px; text-align: center">
        <h4>{{$t('Percorso attività')}}</h4>
      </ion-col>
      <ion-col size="4"
        ><ion-button  @click="NavigaTo()">
          <ion-icon slot="start" :icon="navigate"></ion-icon>
          {{$t('Naviga')}}
        </ion-button></ion-col
      >
    </ion-row>
    <ion-row style="padding: 0px; margin: 0px" v-if="VisualizzaMappa"
      ><ion-col size="12" style="padding: 0px; margin: 0px">
        <!--https://vue-map.netlify.app/docs/#basic-usage-->
        <GMapMap
          :scrollwheel="false"
          ref="Mappa"
          :clickable="false"
          :draggable="false"
          :center="{ lat: Dettagli.Ind_latp, lng: Dettagli.Ind_lonp }"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; height: 400px"
        >
        </GMapMap> </ion-col
    ></ion-row>
  </base-layout>
</template>

<script>
import { BaseLayout, IonRow, IonCol, IonChip, IonLabel, isPlatform, IonButton, IonIcon } from "@ionic/vue";
import { DbParamType } from "../components/shared/DbParamType";
import { CommandExecutionType } from "../components/shared/CommandExecutionType";
import { ParameterDirection } from "../components/shared/ParameterDirection";
import { CommandParam } from "../components/shared/CommandParam";
import { dataBoxCall } from "../components/shared/GlobalCallSP";
import { navigate } from "ionicons/icons";
export default {
  name: "AttivitaDet",
  components: {
    BaseLayout,
    IonRow,
    IonCol,
    IonChip,
    IonLabel,
    IonButton,
    IonIcon,
  },

  data() {
    return {
      Dettagli: {},
      arcSezioni: [],
      pAtt_Codi: "",
      ViewList: true,
      PercorsoOK: false,
      DatiOK: false,
      MappaOK: false,
      gMaps: {}, //oggetto mappa inizializzato
      VisualizzaMappa: true,
      navigate,

      //path: [
      //    {lat: this.Dettagli.Ind_latp, lng: this.Dettagli.Ind_lonp},
      //    {lat: this.Dettagli.Ind_latd, lng: this.Dettagli.Ind_lond},
      //]
    };
  },

  methods: {
    NavigaTo() {
        let  lat, lng;

        lat = this.Dettagli.Ind_latd;
        lng = this.Dettagli.Ind_lond;


      if (!lat || !lng) {
        return;
      }

      if (isPlatform("ios") && (isPlatform("iphone") || isPlatform("ipad"))) {
        window.open("http://maps.apple.com/?q=#&ll=#" + lat + ",#" + lng + "&near=#" + lat + ",#" + lng, "_system", "location=yes");
      } else if (isPlatform("android")) {
        window.open("geo:" + lat + "," + lng + "?q=" + lat + "," + lng );
      } else {
        window.open("http://maps.google.com/maps?daddr=" + lat + "," + lng + "&amp;ll=");
      }
    },
    DisegnaPercorso() {
      //se percorso già ok esco
      if (this.PercorsoOK) {
        return;
      }

      //non eseguo se non ci sono i dati o se la mappa non è ok
      if (!this.DatiOK || !this.MappaOK) {
        return;
      }
      let directionsDisplay = new window.google.maps.DirectionsRenderer();
      directionsDisplay.setMap(this.gMaps);

      let start = new window.google.maps.LatLng(this.Dettagli.Ind_latp, this.Dettagli.Ind_lonp);
      let end = new window.google.maps.LatLng(this.Dettagli.Ind_latd, this.Dettagli.Ind_lond);
      let request = {
        origin: start,
        destination: end,
        travelMode: window.google.maps.DirectionsTravelMode.DRIVING,
      };
      let directionsService = new window.google.maps.DirectionsService();
      directionsService.route(request, function (response, status) {
        if (status == window.google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response);
        }
      });
      window.google.maps.event.trigger(this.gMaps, "resize");

      console.log("ok posso procedere ho la mappa ed i dati " + directionsDisplay);
      this.PercorsoOK = true;
    },
    GetDati() {
      const self = this;
      let prm = [];
      // inline

      prm.push(new CommandParam("@Att_codi", "", DbParamType.Int32, 0, ParameterDirection.Input, this.pAtt_Codi));
      prm.push(new CommandParam("@Lin_codi", "", DbParamType.Int32, 0, ParameterDirection.Input, this.$LIN_CODI));
      prm.push(new CommandParam("@Con_toke", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$CON_TOKE));
      prm.push(new CommandParam("@Ind_codi", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$IND_CODI));
      dataBoxCall
        .Exec(prm, "stpF_Tabella_AttivitaRicreative_Anteprima02_lst", true, "", CommandExecutionType.ExecuteQuery, false, this.$DATABOX_CFG)
        .then(function (data) {
          if (data && data.RecordSet.Table.length > 0) {
            self.Dettagli = data.RecordSet.Table[0];
            self.arcSezioni = data.RecordSet.Table1;
          } else {
            self.arcSezioni = [];
          }

          if (!self.Dettagli.Ind_latp || !self.Dettagli.Ind_latd) {
            self.VisualizzaMappa = false;
          } else {
            self.DatiOK = true;
            //provo ad inizializzare la mappa
            self.DisegnaPercorso();
          }
        })
        .catch(function (er) {
          console.log("return normale no data" + er);
        });
    },
  },
  mounted() {
    this.pAtt_Codi = this.$route.params.pAtt_Codi;
    this.GetDati();
    //inizializzo variabile mappa
    this.$refs.Mappa.$mapPromise.then((map) => {
      // inizializzo oggetto mappa
      this.gMaps = map;
      this.MappaOK = true;
      //provo a chiamare inizializzazione della mappa
      this.DisegnaPercorso();
    });
  },
};
</script>
